<template>
  <div class="col-12">
    <input-group v-model="config.name" placeholder="Enter Message Name" label="Name" />
    <div style="color: white">
      Push id: {{ this.$route.params.id }}
    </div>
    <div>
      <div class="btn btn-sm" v-if="this.$route.params.id" @click="resetStatistics"> Reset Statistics On Edit</div>
    </div>
    <div v-if="initialMessageState" class="alert alert-info mt-3">
      Editing message: <strong>{{ initialMessageState.name }}</strong> (Status: {{ initialMessageState.status }})
    </div>
    <div v-if="initialMessageState && initialMessageState.audience_count && initialMessageState.audience_count.status === 'DONE' && !isAudienceUpdated" class="alert alert-success mt-3">
      <i class="fas fa-check-circle"></i>
      This message has a pre-calculated audience count of <strong>{{ initialMessageState.audience_count.value }}</strong>.
    </div>

    <audience-section v-model="config.audience" title="1.Audience" />
    <div class="template-picker">
      <div>
        Message
      </div>
      <select v-model="config.messages[0]" class="form-control">
        <option disabled value="">Pick Automated Message From Templates</option>
        <option v-for="template in templates" v-bind:key="template.id"
          :value="template.messages && template.messages[0] ? { ...template.messages[0], templateId: template.id } : null">
          <span>{{ template.name }} </span>
        </option>
      </select>
    </div>
    <message-section v-model="config.messages[0]" title="2.Message" />
    <schedule-section v-model="config.schedule" title="3.Scheduled" :schedule="config.schedule" />
    <div id="spinner" class="spinner" v-show="showSpinner">
      <Spinner></Spinner>
    </div>
    <div class="message-buttons col-12">
      <div class="message-button" id="button-confirm" @click="openConfirmModal" :class="{ disabled: isConfirmDisabled }" :aria-disabled="isConfirmDisabled">
        CONFIRM
      </div>
      <div class="message-button" id="button-draft" @click="submitMessage(true)">
        {{ draftButtonLabel }}
      </div>
    </div>

    <!-- ActionModal for simple notifications -->
    <action-modal
      :show="modalState.show"
      :title="modalState.title"
      :body="modalState.body"
      :buttons="modalState.buttons"
      @close="closeModal"
    />

    <!-- Send message modal for message sending -->
    <div class="send-message-modal-container" :style="{ display: sendMessageModalOpen ? 'flex' : 'none' }"
         @click="closeSendMessageModal">
      <div id="send-message-body" :style="{ display: sendMessageModalOpen ? 'flex' : 'none' }">
        <div class="send-message-modal-wrapper">
          <span>Confirm Before Sending</span>
          <div class="modal-row">
            <div class="modal-row-heading">
              Included Segments
            </div>
            <div class="modal-row-content">
              {{ config.audience.includedAudience ? config.audience.includedAudience.map(item => item.name).join(', ')
              : ''
              }}
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-row-heading">
              Recipients
            </div>
            <div v-if="typeof audienceCount == 'number'" class="modal-row-content">
              {{ audienceCount }}
            </div>
            <div v-else class="modal-row-content" style="color: red;">
              {{ audienceCount }}
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-row-heading">
              Title
            </div>
            <div class="modal-row-content">
              {{ config.messages && config.messages[0] && config.messages[0].messageBody && config.messages[0].messageBody.default ? config.messages[0].messageBody.default.title : 'No title' }}
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-row-heading">
              Image
            </div>
            <div class="modal-row-content">
              <img v-if="config.messages && config.messages[0] && config.messages[0].messageBody && config.messages[0].messageBody.image" v-bind:src="config.messages[0].messageBody.image" />
              <span v-else>No image</span>
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-row-heading">
              Content
            </div>
            <div class="modal-row-content">
              {{ config.messages && config.messages[0] && config.messages[0].messageBody && config.messages[0].messageBody.default ? config.messages[0].messageBody.default.body : 'No content' }}
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-row-heading">
              Scheduled For
            </div>
            <div class="modal-row-content">
              {{ config.schedule.sendImmediately ? 'Right away' : dateFormatter(config.schedule.sendTime) }}
            </div>
          </div>
          <div class="modal-buttons">
            <div class="modal-button secondary" @click="closeSendMessageModal">
              CANCEL
            </div>
            <div class="modal-button primary" @click="() => { submitMessage(false); closeSendMessageModal(); }">
              SEND MESSAGE
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MessageSection from "@/views/PushNotification/Components/Message"
import AudienceSection from "@/views/PushNotification/Components/Audience";
import ScheduleSection from "@/views/PushNotification/Components/Schedule";
import InputGroup from "@/views/PushNotification/UIComponents/InputGroup";
import ActionModal from "@/views/PushNotification/UIComponents/ActionModal";
import formatters from "@/util/formatters"
import notify from "@/util/notification";
import Spinner from '../../../components/Spinner.vue';
import { permissionsMixin } from '@/mixins/permissions.mixin';

const isLocal = window.location.href.indexOf("localhost:8080") >= 0;
const audienceCountUrl = isLocal ? "http://localhost:5002/audienceCount" : "/audienceCount";
const cancelBigqueryJobUrl = isLocal ? "http://localhost:5002/audienceCount/cancel-bigquery-job" : "/audienceCount/cancel-bigquery-job";

export default {
  name: "Message",
  mixins: [permissionsMixin],
  components: {
    InputGroup,
    MessageSection,
    AudienceSection,
    ScheduleSection,
    Spinner,
    ActionModal
  },
  computed: {
    messages() {
      const messages = this.$store.getters.messages
      console.log('Messages from store:', messages)
      return messages || []
    },
    appId() {
      return this.$store.getters.activeApp
    },
    templates() {
      const templates = this.$store.getters.templateMessages
      console.log('Templates from store:', templates)
      return templates || []
    },
    draftButtonLabel() {
      return this.initialMessageState && this.initialMessageState.status === 'delivered' ? 'Duplicate and Save as Draft' : 'Save as Draft';
    },
    isConfirmDisabled() {
      return !this.permissionsLoaded || (this.initialMessageState && this.initialMessageState.status === 'delivered');
    }
  },

  mounted() {
    console.log('Message component mounted, config:', this.config)
    console.log('Messages from store:', this.messages)

    // Ensure messages array is initialized
    if (!this.config.messages || this.config.messages.length === 0) {
      console.log('Initializing messages array')
      this.config.messages = [{
        messageBody: {
          default: {
            title: "Title",
            subtitle: "Subtitle",
            body: "Message"
          },
          image: ""
        },
        platformSettings: {
          badges: "dontSet",
          badgeCount: 0,
          sound: "default",
          mutableContent: false
        },
        otherSettings: {
          additionalData: [],
          timeToLive: "",
          category: ""
        }
      }];
    }

    const messageId = this.$route.params.id;
    if (messageId) {
      const editMessage = this.messages.find(m => m.id === messageId);
      if (editMessage) {
        console.log('Found edit message:', editMessage);
        this.config = JSON.parse(JSON.stringify(editMessage)); // this is the added/saved message data.
        if (this.config.schedule && typeof this.config.schedule.sendTime === 'string') {
          this.config.schedule.sendTime = Date.parse(this.config.schedule.sendTime);
        }
        this.initialMessageState = JSON.parse(JSON.stringify(editMessage)); // this is used to compare overall message state while editing the message.
        this.initialAudienceState = JSON.parse(JSON.stringify(editMessage.audience));// this is used to compare audience values while editing the message.

        if (editMessage.status === 'delivered') {
          notify('This message is already delivered. If you want to make changes, you need to duplicate and edit it.', 'warning');
        }

        if (editMessage.audience_count && editMessage.audience_count.status === 'TIMEOUT') {
          this.handleTimeoutStateOnLoad();
        }
        
        if (editMessage.audience_count && editMessage.audience_count.status === 'ERROR') {
          this.handleErrorStateOnLoad();
        }
      }
    }
  },
  data() {
    return {
      shouldResetStatistics: true,
      dateFormatter: formatters.dateFormatter,
      sendMessageModalOpen: false,
      audienceCount: 0,
      pendingJobId: null,
      showSpinner: false,
      config: {
        // status
        // statistics
        name: "",
        audience: {
          sendToAll: true,
          includedAudience: [],
          excludedAudience: [],
          percentage: 100
        },
        messages: [{
          messageBody: {
            default: {
              title: "Title",
              subtitle: "Subtitle",
              body: "Message"
            },
            image: ""
          },
          platformSettings: {
            badges: "dontSet",
            badgeCount: 0,
            sound: "default",
            mutableContent: false
          },
          otherSettings: {
            additionalData: [],
            timeToLive: "",
            category: ""
          }
        }],
        schedule: {
          sendImmediately: true,
          sendTime: "",
          withLocalTimezone: false
        }
      },
      initialMessageState: null,
      initialAudienceState: null,
      isAudienceUpdated: false,
      modalState: { 
        show: false, 
        title: '', 
        body: '', 
        buttons: [] 
      },
    }
  },
  methods: {
    // --- MODAL HELPERS ---
    showModal(title, body, buttons) { this.modalState = { show: true, title, body, buttons }; },
    closeModal() { this.modalState.show = false; },
    closeSendMessageModal() { this.sendMessageModalOpen = false;  },
    validateUserInput() {
      if (!this.config.name) {
        notify('Name cannot be empty!', 'error')
        return false;
      }
      if (!this.config.audience.sendToAll && this.config.audience.includedAudience.length === 0 && this.config.audience.excludedAudience.length === 0) {
        notify('No audience is selected.', 'error')
        return false;
      }
      if (!this.config.schedule.sendImmediately && !this.config.schedule.sendTime) {
        notify('Schedule time should be specified.', 'error')
        return false;
      }

      if (!this.config.schedule.sendImmediately && this.config.schedule.sendTime && this.config.schedule.sendTime < Date.now()) {
        notify('Schedule time is in the past. Please choose a future time.', 'error')
        return false;
      }
      
      return true;
    },

    // --- PRIMARY GATEKEEPER METHOD ---
    async openConfirmModal() {
      console.log(this.shouldResetStatistics);
      console.log('Permission check - canSendPushNotifications:', this.canSendPushNotifications);
      console.log('Permission check - permissionsLoaded:', this.permissionsLoaded);
      console.log('Permission check - userCapabilities:', this.userCapabilities);
      console.log('Permission check - authContext:', this.authContext);
      console.log('Permission check - user groups:', this.$store.getters.user?.groups);
      console.log('Permission check - user email:', this.$store.getters.user?.email);
      
      if (!this.validateUserInput()) return;
      
      // Ensure permissions are loaded before checking
      if (!this.permissionsLoaded) {
        console.log('Permissions not loaded yet, waiting...');
        try {
          await this.initializePermissions();
          console.log('Permissions loaded, rechecking...');
        } catch (error) {
          console.error('Failed to load permissions:', error);
          return notify('Failed to load permissions. Please try again.', 'error')
        }
      }
      
      if (!this.canSendPushNotifications) {
        console.log('Permission denied: User cannot send push notifications');
        console.log('User groups:', this.$store.getters.user?.groups);
        console.log('User permissions:', this.userCapabilities);
        return notify('You are not authorized to send push notifications', 'error')
      }
      console.log('Permission granted: User can send push notifications');

      if (this.initialMessageState && this.initialMessageState.status === 'delivered') {
        return notify('This message is already delivered. If you want to make changes, create a copy and edit it.', 'warning'); // fallback for disabling confirm button
      }
      const audienceCountStatus = this.initialMessageState && this.initialMessageState.audience_count && this.initialMessageState.audience_count.status;
      
      if (audienceCountStatus === 'PENDING') {
        return notify('The audience count is pending. Please wait for it to complete.', 'warning');
      }

      if (this.isAudienceUpdated && this.initialMessageState.audience_count) {
        const body = `<p>You have updated the audience configuration. The audience count must be recalculated. This may change the message's status to a draft.</p><p>Are you sure you want to continue?</p>`;
        this.showModal('Audience Updated', body, [
          { text: 'CANCEL', class: 'secondary', action: this.closeModal },
          { text: 'CONTINUE', class: 'primary', action: this.executeAudienceCalculation }
        ]);
      } else if (audienceCountStatus === 'DONE') {
        this.showSendMessageModal(this.initialMessageState.audience_count.value);
      } else {
        this.executeAudienceCalculation();
      }
    },

    // --- AUDIENCE CALCULATION ---
    executeAudienceCalculation() {
      this.closeModal();
      this.showSpinner = true;

      const requestBody = { 
        appId: this.appId, 
        includeds: this.config.audience.includedAudience, 
        excludeds: this.config.audience.excludedAudience, 
        isLookerPush: this.config.audience.isLookerPush 
      };
      
      // Include messageId if available (when editing existing message)
      if (this.initialMessageState?.id || this.$route.params.id) {
        requestBody.messageId = this.initialMessageState?.id || this.$route.params.id;
      }

      fetch(audienceCountUrl, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: { authorization: this.$store.getters.pushNotifApiKey, "Content-Type": "application/json" }
      }).then(res => res.json()).then(data => {
        this.showSpinner = false;
        if (data.isTimeout) {
          this.pendingJobId = data.jobId;
          this.showTimeoutModal();
        } else if (data.message === 'DONE') {
          const audienceCount = data.audienceCount.audienceCount;
          this.showSendMessageModal(audienceCount);
        } else {
          notify('Error getting audience count. Please try again.', 'error');
        }
      }).catch(() => {
        this.showSpinner = false;
        notify('Network error while getting audience count.', 'error');
      });
    },

    // --- PAYLOAD PREPARATION HELPER ---
    prepareSchedulePayload(schedule) {
      const schedulePayload = { ...schedule };
      if (schedulePayload.sendImmediately) {
        schedulePayload.sendTime = Date.now();
      }
      else if (!schedulePayload.sendTime) {
        schedulePayload.sendTime = Date.now() + (24 * 60 * 60 * 1000); // if scheduled time is not set (saving as draft case, we do not allow in confirm), set it to 1 day from now
      }
      return schedulePayload;
    },
    resetStatistics(){
      this.shouldResetStatistics = !this.shouldResetStatistics 
    },

    // --- SUBMIT LOGIC ---
    submitMessage(asDraft) {
      if (!this.config.name)
        return notify('Name cannot be empty.', 'error');

      const isEditingDelivered = this.initialMessageState && this.initialMessageState.status === 'delivered';
      
      if (isEditingDelivered) {
        return this.duplicateMessage();
      } else if (this.initialMessageState) {
        return this.editMessage(asDraft);
      } else {
        return this.addMessage(asDraft);
      }
    },
    addMessage(asDraft) {
      this.showSpinner = true;
      const payload = { ...this.config };
      payload.schedule = this.prepareSchedulePayload(payload.schedule);
      payload.status = asDraft ? 'draft' : 'scheduled';
      if (this.audienceCount) {
        payload.audience_count = { status: 'DONE', value: this.audienceCount };
      }
      return this.$store.dispatch('configAdd', { type: 'message', payload }).then((res) => {
        this.showSpinner = false;
        this.$router.push({ name: 'MessagesMessages' });
        return res;
      }).catch(() => {
        this.showSpinner = false;
      });
    },
    editMessage(asDraft) {
      this.showSpinner = true;
      const data = { ...this.config };
      if (this.shouldResetStatistics) {
        data.statistics = {
          sent: 0,
          clicked: 0
        };
      }
      data.schedule = this.prepareSchedulePayload(data.schedule);
      data.status = asDraft ? 'draft' : 'scheduled';
      if (this.audienceCount) {
        data.audience_count = { status: 'DONE', value: this.audienceCount };
      }
      if (!this.pendingJobId && this.initialMessageState?.audience_count && this.isAudienceUpdated) { // If the user saves the message as a draft while we were calculating its audience count, we need to cancel the job and reset the audience count.
        if (this.initialMessageState.audience_count.status === 'PENDING') {
          fetch(cancelBigqueryJobUrl, { method: 'POST', body: JSON.stringify({ jobId: this.initialMessageState.audience_count.jobId, appId: this.appId }), headers: { authorization: this.$store.getters.pushNotifApiKey, "Content-Type": "application/json" } });
        }
        delete data.audience_count;
      }
      const payload = { id: this.$route.params.id, data };
      return this.$store.dispatch('configEdit', { type: 'message', payload }).then(() => {
        this.showSpinner = false;
        this.$router.push({ name: 'MessagesMessages' });
      }).catch(() => {
        this.showSpinner = false;
      });
    },
    duplicateMessage() {
      this.showSpinner = true;
      const payload = { ...this.config };
      delete payload.id;
      payload.name += '_copy';
      payload.status = 'draft';
      payload.schedule = this.prepareSchedulePayload(payload.schedule);
      payload.cloudTaskName = undefined;
      payload.statistics = { sent: 0, clicked: 0 };
      if (this.initialMessageState?.audience_count) {
        delete payload.audience_count;
      }
      return this.$store.dispatch('configAdd', { type: 'message', payload }).then((res) => {
        this.showSpinner = false;
        this.$router.push({ name: 'MessagesMessages' });
        return res;
      }).catch(() => {
        this.showSpinner = false;
      });
    },

    // --- TIMEOUT AND ERROR HANDLERS ---
    showTimeoutModal() {
      const body = `<p>The audience count is taking longer than expected. You can save this message as a draft, and the count will be calculated in the background.</p>`;
      this.showModal('Audience Count Timeout', body, [
        { text: 'CANCEL', class: 'secondary', action: this.cancelBigqueryJob },
        { text: 'SAVE AS DRAFT & CALCULATE', class: 'primary', action: this.saveAsDraftWithPendingJob }
      ]);
    },
    async saveAsDraftWithPendingJob() {
      this.config.audience_count = { status: "PENDING", jobId: this.pendingJobId, value: null };
      
      if (this.initialMessageState) {
        await this.editMessage(true);
      } else {
        await this.addMessage(true);
      }
      
      this.pendingJobId = null;
      this.closeModal();
    },
    async cancelBigqueryJob() {
      if (this.pendingJobId) {
        await fetch(cancelBigqueryJobUrl, { method: 'POST', body: JSON.stringify({ jobId: this.pendingJobId, appId: this.appId }), headers: { authorization: this.$store.getters.pushNotifApiKey, "Content-Type": "application/json" } });
        this.pendingJobId = null;
      }
      this.closeModal();
      notify('Operation cancelled.', 'success');
    },
    handleErrorStateOnLoad() {
      const title = 'Audience Count Failed';
      const body = 'The previous audience count failed. Please try again.';
      this.showModal(title, body, [
        { text: 'OK', class: 'primary', action: this.closeModal }
      ]);
      this.config.audience_count = null;
      if (this.initialMessageState) this.initialMessageState.audience_count = null;
    },
    handleTimeoutStateOnLoad() {
      const isLooker = this.config.audience.isLookerPush;
      const title = 'Audience Count Timed Out';
      const body = isLooker
        ? 'The previous audience count timed out, likely due to an inefficient Looker query. Please review your Look with a BI Analyst.'
        : 'The previous audience count timed out. Please try again.';
      this.showModal(title, body, [
        { text: 'OK', class: 'primary', action: this.closeModal }
      ]);
      this.config.audience_count = null;
      if (this.initialMessageState) this.initialMessageState.audience_count = null;
    },
    showSendMessageModal(count) {
      this.audienceCount = count;
      this.sendMessageModalOpen = true;
    }
  },
  watch: {
    'config.audience': {
      handler(newValue) {
        if (!this.initialMessageState) return;
        if (JSON.stringify(newValue) !== JSON.stringify(this.initialAudienceState)) {
          if (!this.isAudienceUpdated && !(this.initialMessageState.status === 'delivered') && this.initialMessageState.audience_count) {
            notify('Audience configuration has been updated. The audience count will be recalculated if you confirm.', 'warning', 'top-center');
          }
          this.isAudienceUpdated = true;
        } else {
          this.isAudienceUpdated = false;
        }
      },
      deep: true
    },
    'config.messages': {
      handler(newMessages) {
        // Ensure messages array is always initialized
        if (!newMessages || newMessages.length === 0) {
          this.config.messages = [{
            messageBody: {
              default: {
                title: "Title",
                subtitle: "Subtitle",
                body: "Message"
              },
              image: ""
            },
            platformSettings: {
              badges: "dontSet",
              badgeCount: 0,
              sound: "default",
              mutableContent: false
            },
            otherSettings: {
              additionalData: [],
              timeToLive: "",
              category: ""
            }
          }];
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.message-buttons {
  display: flex;
  align-items: center;
}

.message-button {
  padding: 15px 25px;
  margin: 0 10px;
  cursor: pointer;
}

#button-confirm {
  border-radius: 28px;
  background: #BB86FC;
  color: white;
}

#button-confirm:disabled {
  background: #666;
  color: #ccc;
  cursor: not-allowed;
}

#button-draft {
  border-radius: 28px;
  border: 1px solid #BB86FC;
  color: white;
}

.send-message-modal-container {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  overflow-y: auto;
}

.send-message-modal-wrapper {
  padding: 30px 20px;
  background-color: #25253A;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.send-message-modal-wrapper span {
  font-weight: bold;
  font-size: 18px;
  line-height: 16px;
  margin-bottom: 20px;
  /* identical to box height, or 67% */

  letter-spacing: 0.4px;

  /* Primary/200 */

  color: #BB86FC;
}

.modal-row {
  display: flex;
  width: 100%;
  margin: 20px 50px;
}

.modal-row-content {
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.15px;
  color: #A5A5AB;
  width: 50%;
}

.modal-row-heading {
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #BB86FC;
  width: 50%;
  padding-right: 50px;
}

.modal-buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.modal-button {
  margin: 30px 15px 15px;
  padding: 15px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  /* identical to box height, or 89% */

  letter-spacing: 1.25px;
  cursor: pointer;
}

.modal-button.primary {
  background-color: #BB86FC;
  color: white;
}

.modal-button.secondary {
  color: #BB86FC;
}

.spinner {
  display: flex;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 9999;
}

.message-button.disabled {
  background: #666;
  color: #ccc;
  cursor: not-allowed;
  pointer-events: none;
}

#button-confirm.disabled {
  background: #666;
  color: #ccc;
}
</style>